module.exports = __webpack_public_path__ + "a9dc3c7eda3b9ca10659506d77593e3e.png";